//package imports
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { ShareValueDetials, getShareDetials, getSharesList } from "../../services/apiServices/GetServices";
import { buySharesApi } from "../../services/apiServices/PostServices";

//componet imports
import { useForm } from "react-hook-form";
import { Formik, useFormik } from 'formik';
import CustomTextField from "../../utils/resuableComponents/CustomTextfield";
import { CustomDropdown } from "../../utils/resuableComponents/CustomDropdown";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { showToast } from "../../utils/constants/Toaster";
import Loader from "../loadingScreens/Loader";



const SellShares = () => {

    const [amount, setAmount] = useState(0)
    const [shares, setShares] = useState("")
    const [shareData, setShareData] = useState([])
    const [shareType, setShareType] = useState("")
    const [shareTypeValue,setShareTypeValue]=useState(0)
    const [checked, setChecked] = useState(false)
    const termsAndCondtionPath = process.env.REACT_APP_TERMS_CONDTIONS
    const [simpleModal, setSimpleModal] = useState(false)
    const [shareDetails, setShareDetails] = useState([])
    const [shareValueDetails, setShareValueDetails] = useState([])
    const [messageNote, setMessageNote] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [totalShares, setTotalShares] = useState(0)
    const [currentShares,setCurrentShares]=useState("0")
    const history = useHistory();
    const [clicked, setClicked] = useState(false)
    const [isLoader, setIsLoader] = useState(false)

    const [initialValues, setInitialValues] = useState({
        message: '',
    });


    useEffect(() => {
        if (shares !== "" && messageNote !== "" && checked === true && amount !== 0) {
            setErrorMessage("")
        }
    }, [errorMessage])

    const closeSimpleModal = () => {
        setSimpleModal(false)
    }


    //function to handle terms & conditon checkebox
    const handleCheck = () => {
        setChecked(!checked)
    }

    useEffect(() => {
        callShareDetailsApi()
        shareValueDetailsApi()
        getShareList()
    }, [])


    const {
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            checkbox: false,
        },
    });

    const handleMessageChange = event => {
        let message = event;
        if(event.startsWith(" ")){
             message = ""
       }else{
           message= event
       }

        setMessageNote(message)
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            message: message,
        }));
    };

    const getShareList = async () => {
        try {
            const res = await getSharesList("user_share_type");
            if (res.success) {
                
                setShareData(res?.data)
                if(res?.data.length === 0){
                    showToast(3,"share are not available to sell")
                }

            } else {
                console.log("res", res)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    const handleChangeShare = event => {
        const share = event.target.value;
        setCurrentShares(share?.current_shares)
        setShareType(share?.id)
        setShares("")
        setAmount(0)
        setShareTypeValue(share?.value)
      
    };

    const handleSubmitBuy = async () => {
        if (shares > parseInt(currentShares)) {
            showToast(3, "Shares are not sufficient")
        }
        else if (shareDetails?.current_share === "0" || shareDetails?.current_share === null || shareDetails?.current_share === undefined) {
            showToast(3, "Please purchase the share")
        }
        // else if(parseInt(currentShares) === 0 || shares > parseInt(currentShares) ){
        //     showToast(3, "Shares are not available for selected share type")
        // }
        else {
            if (!clicked) {
                setClicked(true)
                setIsLoader(true)
                const reqbody = {
                    sell_shares: shares,
                    share_type: shareType,
                    message: messageNote
                }

                try {
                    const res = await buySharesApi("sellShares", reqbody)
                    if (res?.success) {
                        setShares(0)
                        setMessageNote("")
                        setAmount(0)
                        setErrorMessage("")
                        setChecked(false)
                        setSimpleModal(false)
                        history.push("/customerPortal/myShares")
                        showToast(1, res?.message)
                    } else {
                        console.log("res", res?.message)
                        //showToast(3,res?.message)
                    }
                } catch (error) {
                    console.log("error", error)
                }
            }
        }
    }

    const handleNoOfshares = (share) => {
        const maxLength = 9;
        const truncatedValue = share.slice(0, maxLength);

        setShares(truncatedValue)
        // let shareValue =  findValueInRanges(shareValueDetails,truncatedValue)
        const totalSharesAlreadyPurchased = parseInt(totalShares); // Total shares already purchased
        const newSharesToBePurchased = parseInt(truncatedValue); // New shares to be purchased
        const totalSharesAfterPurchase = totalSharesAlreadyPurchased + newSharesToBePurchased;

        const RANGE_1_MAX = shareValueDetails[0].to_; // Maximum limit for range 1
        const RANGE_2_MIN = RANGE_1_MAX + 1; // Minimum limit for range 2

        const COST_RANGE_1 = shareValueDetails[0].value; // Rs per share for range 1
        const COST_RANGE_2 = shareValueDetails[1].value; // Rs per share for range 2

        let range1Shares = 0;
        let range2Shares = 0;

        if (totalSharesAfterPurchase <= RANGE_1_MAX) {
            // All newly purchased shares fall within range 1
            range1Shares = newSharesToBePurchased;
        } else if (totalSharesAlreadyPurchased < RANGE_1_MAX) {
            // Some newly purchased shares fall within range 1 and some in range 2
            range1Shares = RANGE_1_MAX - totalSharesAlreadyPurchased;

            range2Shares = newSharesToBePurchased - range1Shares;
        } else {
            // All newly purchased shares fall within range 2
            range2Shares = newSharesToBePurchased;
        }

        const costRange1 = range1Shares * COST_RANGE_1;

        // Calculate cost for range 2 shares
        const costRange2 = range2Shares * COST_RANGE_2;

        // Calculate total cost
        // const totalCost = costRange1 + costRange2;
        const totalCost = truncatedValue * shareTypeValue;
        setAmount(totalCost)
    }

    //function to call share value details
    const callShareDetailsApi = async () => {
        try {
            const res = await getShareDetials("shares")
            if (res?.success) {
                if (res?.message !== "No shares available") {
                    setShareDetails(res?.data[0])
                } else {
                    setShareDetails([])
                }

            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }

    }

    //function to call share value details
    const shareValueDetailsApi = async () => {
        try {
            const res = await ShareValueDetials("osanShares")
            if (res?.success) {
                setShareValueDetails(res?.osanShares)
                setTotalShares(res?.total_shares !== null ? res?.total_shares : 0)
            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }

    }

    const handleSimpleModal = () => {

        if (shares === "" || messageNote === "" || amount === 0  ) {
            setErrorMessage("Please enter the required fields above")
        }
        else if (checked === false) {
            setErrorMessage('Please select the check box')
        }else if(parseInt(currentShares) === 0 ){
            showToast(3,'Shares are not available for selected share type')
        }
        else if(  shares > parseInt(currentShares) ){
            showToast(3, `Shares are not sufficient for selected share type`)
        } 
        else if (shares !== "" && messageNote !== "" && checked === true && amount !== 0 && parseInt(currentShares) !== 0 && (shares <= parseInt(currentShares)) ) {
            setErrorMessage("")
            setSimpleModal(true);
            setClicked(false)
        }
    }

    const validate = values => {
        const errors = {};
        // Validate email
        if (!values.message) {
            errors.message = 'Required'
        }
        return errors;
    };

    //function to handle on click of space submit
    const handleKeyDown = (event) => {
        // Check if the pressed key is the space key and if the submit button is focused
        if (event.key === ' ' || event.key === 'Spacebar') {
            const submitButton = document.activeElement;
            if (submitButton && submitButton.type === 'submit') {
                // Prevent the default action (form submission) when the space key is pressed
                event.preventDefault();
            }
        }
    };

    const formik = useFormik({
        initialValues: initialValues,
        validate,
        onSubmit: values => {
            // handleSimpleModal();
            // Handle form submission
            console.log(values);
            // history.push("/customerPortal/clientDashboard")
            // resetForm();
        },
    });



    return (
        <div class="col-md-12" >
            {isLoader ? <Loader /> : null}
            <h1 class="fs-4 w-100 border-bottom border-top p-1 mb-xxl-5 mb-xl-0">
                Sell Share
            </h1>
            <div class="container-fluid full-height">
                <div class="row">
                    <div class="col-12 d-flex flex-row justify-content-center align-items-center  mt-xl-0">
                        <div class="d-flex flex-column col-md-6 justify-content-center " >
                            <div class="mx-4  my-1">
                                <p class="text-black fw-bold">Follow Steps To Sell Shares:</p>
                                <ul class="paraColor listFontSize w-90">
                                    <li class="roboto"> <span class="fw-bold paraColor" >Fill Share Sell Request Form:</span> Complete the share sell request form with all details and a brief message indicating the intention to sell shares.</li>
                                    <li class="roboto"> <span class="fw-bold paraColor">Submit the Form:</span> Submit the form with all the required details regarding the shares you wish to sell.</li>
                                    <li class="roboto"><span class="fw-bold paraColor">Admin Review:</span>  The admin will review your request to sell the Osan Shares.</li>
                                    <li class="roboto"><span class="fw-bold paraColor">Request Approval:</span> Upon review and verification, the admin will approve your request to sell the shares.</li>
                                    <li class="roboto"> <span class="fw-bold paraColor">Amount Credited:</span> After approval, the amount corresponding to the sold shares will be credited to your account within 4-5 business days.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <form onKeyDown={handleKeyDown} onSubmit={formik.handleSubmit} autoComplete="off">
                                <div class="d-flex flex-column border shadow border-1  h-75 m-2">
                                    <div class="mx-2 my-1 montserrat ">
                                        <h5 class="fw-bold m-0 " >Submit Request To Sell Shares</h5>
                                    </div>

                                    <div class="d-flex flex-column border m-2">
                                        <div class="d-flex  justify-content-between align-items-center border-bottom p-2 flex-row">

                                            <div class="w-75">
                                                <h6 class="mb-0">Shares type*</h6>
                                            </div>
                                            <div class="w-50 text-center me-3" >
                                                <CustomDropdown data={shareData}
                                                    onChange={(e) => {
                                                        handleChangeShare(e)
                                                    }}
                                                    value={shareType}
                                                     fromName="share"

                                                    // error={formik.touched.state && Boolean(formik.errors.state)}
                                                    // helperText={formik.touched.state ? formik.errors.state : ''}
                                                    height={"35px"}
                                                    name="share"
                                                />
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center border-bottom p-2 flex-row">
                                            <div class="w-75">
                                                <h6 class="mb-0">Current Investment </h6>
                                            </div>
                                            <div class=" m-0 me-1 w-25 text-start" >
                                                <h6 class="mb-0 ">₹{shareDetails?.investment === null || shareDetails?.investment === undefined || shareDetails?.investment === "0" ? "0" : shareDetails?.investment}</h6>
                                            </div>
                                        </div>
                                        <div class="d-flex  justify-content-center align-items-center border-bottom p-2 flex-row">
                                            <div class="w-75">
                                                <h6 class="mb-0">Current Shares</h6>
                                            </div>
                                            <div class="m-0 me-1 w-25 text-start" >
                                                <h6 class="mb-0 ">{shareDetails?.current_share === null || shareDetails?.current_share === undefined || shareDetails?.current_share === "0" ? "0" : shareDetails?.current_share} </h6>
                                            </div>
                                        </div>
                                        <div class="d-flex  justify-content-between align-items-center border-bottom p-2 flex-row">

                                            <div class="w-50">
                                                <h6 class="mb-0">Sell Shares *</h6>
                                            </div>
                                            <div class="w-50 text-end me-1" >
                                                {/* <i class="bi bi-dash "></i> */}
                                                <input value={shares}
                                                    type="Number"
                                                    onChange={(e) => {
                                                        handleNoOfshares(e.target.value)
                                                    }}
                                                    class="amountStyle shadow"
                                                    placeholder="0"
                                                />
                                                {/* <i class="bi bi-plus"></i> */}
                                            </div>
                                        </div>
                                        <div class="d-flex  justify-content-between align-items-center border-bottom p-2 flex-row">
                                            <div class="w-75">
                                                <h6 class="mb-0">Approx. Amount</h6>
                                            </div>
                                            <div class=" w-25 text-start" >
                                                <h6 class="mb-0">₹{isNaN(amount) ? 0 : amount}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mx-2 ">
                                        <CustomTextField
                                            control={control}
                                            header={"Message *"}
                                            name="message"
                                            size="small"
                                            value={messageNote}
                                            placeholder={"Hello there,I would like to talk about how to..."}
                                            multiline={true}
                                            rows={3}
                                            inputProps={{
                                                min: 3,
                                                maxLength: 250,
                                            }}
                                            error={formik.touched.message && Boolean(formik.errors.message)}
                                            helperText={formik.touched.message ? formik.errors.message : ''}
                                            InputProps={{ sx: { borderRadius: "12px" } }}
                                            onChange={(e) => {
                                                const result = e.replace(/\D/g, "");
                                                // setMessage(e)
                                                handleMessageChange(e)
                                            }}
                                        />
                                    </div>

                                    <div class="d-flex flex-row p-0 my-2 mx-2 form-check align-self-start ">
                                        <div>
                                            <input
                                                type="checkbox"
                                                checked={checked}
                                                onChange={handleCheck}
                                            />
                                        </div>
                                        <label class="form-check-label mx-2" for="exampleCheck1">I have read & agree to the  <a href={termsAndCondtionPath} class="text-decoration-none previewColor " target="_blank">
                                            <span >Terms & Conditions</span>
                                        </a>   </label>
                                    </div>
                                    <div class="mx-2">
                                        {
                                            errorMessage !== "" ? <h6 class="text-danger">{errorMessage}</h6> : null
                                        }
                                    </div>

                                    <div class="my-2 align-self-center">
                                        <button type="button" onClick={() => handleSimpleModal()} variant="contained" class="primaryButton px-3">
                                            Submit
                                        </button>
                                    </div>

                                    <CustomModal
                                        close={closeSimpleModal}
                                        open={simpleModal}
                                        modalContent={"Are you sure want to sell the shares?"}
                                        Action={handleSubmitBuy}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SellShares